import React from "react";
export const Team = () => {
  const team = [{
    name: "Irina Stoicescu",
    image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4fc3a367-e3b8-4784-bea9-8f535505ab88/576afe7f-c6ef-4711-949d-af7913a3fc92/irina_lam.jpg",
    linkedin: "https://www.linkedin.com/in/irina-lam/",
    bio: ["LinkedIn outreach Agency owner with over 60 LinkedIn accounts managed", "Over 100K LinkedIn messages sent per year", "Never had a LinkedIn account blocked by LinkedIn"]
  }, {
    name: "Lucian Cretu",
    image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4fc3a367-e3b8-4784-bea9-8f535505ab88/576afe7f-c6ef-4711-949d-af7913a3fc92/lucian_cretu.jpg",
    linkedin: "https://www.linkedin.com/in/luciancretu/",
    bio: ["Tech Entrepreneur driving scalable solutions", "Helped 1,000+ people secure new opportunities", "Startup Enthusiast fueling early-stage growth"]
  }];
  return <section className="w-full bg-white py-16" data-id="element-242">
      <div className="max-w-4xl mx-auto px-4" data-id="element-243">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-244">
          Who We Are & Why You Can Trust Us
        </h2>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-245">
          We're Irina and Lucian, two professionals who believe that anyone
          should be able to monetize their LinkedIn presence responsibly. We're
          here to make that happen—safely and transparently.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-246">
          {team.map(member => <div key={member.name} className="bg-white rounded-lg p-6 border shadow-sm" data-id="element-247">
              <div className="flex flex-col items-center text-center mb-4" data-id="element-248">
                <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mb-4 object-cover" data-id="element-249" />
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="text-xl font-semibold text-emerald-600 hover:text-emerald-700 hover:underline" data-id="element-250">
                  {member.name}
                </a>
              </div>
              <ul className="space-y-2" data-id="element-251">
                {member.bio.map((point, index) => <li key={index} className="text-gray-600" data-id="element-252">
                    • {point}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};